import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import * as EventObjectActions from 'actions/EventObjectActions';
import * as UiActions from 'actions/UiActions';
import * as BetslipActions from 'actions/BetslipActions';
import ViewSpinner from 'components/ViewSpinner';
import SportRadarWidget from 'components/SportRadarWidget';
import 'css/HomePage.scss';
import CommonMatchCenterPlaceholder from 'components/CommonMatchCenterPlaceholder';
import 'css/GamePageNewWeb.scss';
import {
    ANBEFALET_SPORT_ID,
    APP_PATH,
    goToWithBasePath,
} from '../../constants/appConfig';
import { MARKET_TYPE_GROUPS_ID, SPORTS } from 'constants/appConfig';
import { detectMobile, isTerminal, scrollToTop } from 'utils/UiHelper';
import HorseRacingStream from 'features/HorseRacingStream';
import BackButton from '../../components/BackButton/BackButton';
import Text from '../../ui/Text';
import GamePageTabView from '../../components/GamePageTabView/GamePageTabView';
import { getPopularMarkets } from '../../utils/GetMostPopularMarkets';
import MatchCenterAndLiveStream from '../../features/MatchCenterAndLiveStream/MatchCenterAndLiveStream';
import { replaceNumbersInString } from '../../utils/Helper';
import { setActiveSportId as SetActiveSportId } from '../../actions/UiSportLiveActions';
import { SPORTS_ALLOW_MATCH_CENTER } from '../../constants/allowMatchCenter';

const PRYORITED_MARKETS = [
    MARKET_TYPE_GROUPS_ID.CUSTOM_BET,
    MARKET_TYPE_GROUPS_ID._1X2,
    MARKET_TYPE_GROUPS_ID.BET_REQUEST,
];

const GamePageLayout = ({
    params,
    eventObjectActions,
    eventObject,
    betslip,
    uiActions,
    auth,
    betslipActions,
    setActiveSportId,
    oldActiveSportId,
    isLeftSideBarOpen,
}) => {
    const [sideMatchCenter, setSideMatchCenter] = useState(true);
    const [eventTitle, setEventTitle] = useState('');
    const [orderedMarkets, setOrderedMarkets] = useState([]);
    const [rendering, setRendering] = useState(true);
    const [marketFromLink, setMarketFromLink] = useState({});
    let pending = false;

    const firebaseChildAddedHandler = (data) => {
        if (eventObject.data && eventObject.fetched) {
            eventObjectActions.updateMarket(data.val());
        }
    };

    const firebaseChildChangedHandler = (data) => {
        let dataUpd = data.val();
        if (eventObject && dataUpd.marketTypeGroup) {
            eventObjectActions.updateMarket(dataUpd);
        }

        betslipActions.updateMarket({}, data, true);
    };

    const firebaseChildRemovedHandler = (data) => {
        if (eventObject) {
            eventObjectActions.removeMarket(data.val().marketId);

            if (
                !betslip.disabled &&
                betslip.hasMarkets &&
                betslip.hasMarkets.indexOf(data.val().marketId) > -1
            ) {
                betslipActions.updateMarket(
                    betslip,
                    data.val(),
                    eventObject.eventId,
                    eventObject.sportId
                );
            }
        }
    };

    useEffect(() => {
        checkDeviceWidth();
        window.addEventListener('resize', checkDeviceWidth);
        //checkAvailableBet();
        scrollToTop();
        setRendering(false);
        return () => {
            eventObjectActions.resetMarkets();
            setOrderedMarkets([]);
            window.removeEventListener('resize', checkDeviceWidth);
            let markets = window.firebase
                .database()
                .ref('markets/' + params.id);
            markets.off('child_added', firebaseChildAddedHandler);
            markets.off('child_changed', firebaseChildChangedHandler);
            markets.off('child_removed', firebaseChildRemovedHandler);
        };
    }, []);

    useEffect(
        () => {
            eventObjectActions.getEventObject(params.id);
            let markets = window.firebase
                .database()
                .ref('markets/' + params.id);
            markets.on('child_added', firebaseChildAddedHandler);
            markets.on('child_changed', firebaseChildChangedHandler);
            markets.on('child_removed', firebaseChildRemovedHandler);
        },
        [params?.id]
    );

    useEffect(
        () => {
            if (
                betslip.regularBetBetslipFetched ||
                betslip.customBetBetslipFetched
            ) {
                checkAvailableBet();
            }
        },
        [betslip.regularBetBetslipFetched, betslip.customBetBetslipFetched]
    );

    useEffect(
        () => {
            if (eventObject.marketsShouldBeUpdated) {
                eventObjectActions.getEventObject(params.id);
            }
        },
        [eventObject.marketsShouldBeUpdated]
    );

    useEffect(
        () => {
            if (eventObject.eventIsFinished) {
                browserHistory.push('/sport/');
            }
        },
        [eventObject.eventIsFinished]
    );

    useEffect(
        () => {
            if (eventObject?.data) {
                getDynamicOrderedMarketGroups();
            }
        },
        [
            eventObject?.data?.marketList?.length,
            eventObject?.data?.customBetMarkets?.length,
        ]
    );

    useEffect(
        () => {
            if (
                (betslip.customBetEventId !== null &&
                    betslip.hasMarkets.length > 0 &&
                    !eventObject.isFirstRendering &&
                    !rendering &&
                    !eventObject.isPendingCustomBetUpdate) ||
                (betslip.customBetEventId === null &&
                    betslip.hasMarkets.length === 0 &&
                    !eventObject.isFirstRendering &&
                    !rendering &&
                    !eventObject.isPendingCustomBetUpdate)
            ) {
                eventObjectActions.updateCustomBetMarkets(
                    params.id,
                    betslip.hasMarkets.length === 0 &&
                        !eventObject.isFirstRendering
                );
            }
        },
        [betslip.hasMarkets.length]
    );

    useEffect(
        () => {
            if (
                betslip.betslipResetedFromLink === true &&
                betslip.hasMarkets.length === 0
            ) {
                placeBetFromLink();
                betslipActions.changeStatusBetslipResetFromLink(false);
            }
        },
        [betslip.betslipResetedFromLink]
    );

    const placeBetFromLink = () => {
        if (marketFromLink.action === 'add') {
            betslipActions.addMarket(
                marketFromLink.marketId,
                marketFromLink.betNumber,
                marketFromLink.odds,
                marketFromLink.live,
                0,
                betslip.hasMarkets,
                detectMobile()
            );
            setMarketFromLink({});
            browserHistory.push(goToWithBasePath(`/kamp/${params.id}`));
        }
    };

    useEffect(
        () => {
            if (eventObject?.data?.eventId) {
                getDynamicOrderedMarketGroups();
            }
            if (
                eventObject?.data?.tradeLive &&
                eventObject?.data?.live &&
                window.locationHistory.length > 0 &&
                window.locationHistory[0].includes('live')
            ) {
                if (oldActiveSportId === ANBEFALET_SPORT_ID) {
                    setActiveSportId(oldActiveSportId);
                } else {
                    setActiveSportId(eventObject.data.sportId);
                }
            }
        },
        [eventObject.data?.eventId]
    );

    useEffect(
        () => {
            if (
                eventObject.updatedMarkets &&
                !rendering &&
                eventObject.fetched
            ) {
                getDynamicOrderedMarketGroups();
            }
        },
        [eventObject.updatedMarkets]
    );

    useEffect(
        () => {
            if (
                !eventObject.isPendingCustomBetUpdate &&
                !rendering &&
                eventObject?.data?.marketList?.length > 0
            ) {
                updateCustomBetMarkets();
            }
        },
        [eventObject.isPendingCustomBetUpdate]
    );

    useEffect(
        () => {
            if (eventObject.error === 'Ugyldig kamp') {
                if (
                    window.locationHistory &&
                    window.locationHistory.length > 1
                ) {
                    browserHistory.replace(window.locationHistory[0]);
                } else {
                    browserHistory.replace('/');
                }
            }
        },
        [eventObject.error]
    );

    const checkAvailableBet = () => {
        if (window.location.href.includes('?')) {
            let locationArr = window.location.href.split('?')[1].split('&');
            let marketId = Number(replaceNumbersInString(locationArr[0]));
            let betNumber = Number(replaceNumbersInString(locationArr[1]));
            let odds = Number(locationArr[2].replace('odds=', ''));
            let live = replaceNumbersInString(locationArr[3]);
            let action = locationArr[4].replace('action=', '');

            if (
                betslip.regularBetBetslipFetched &&
                betslip.hasMarkets.length > 0 &&
                betslip.customBetBetslipFetched === false
            ) {
                betslipActions.clearAllMarkets(true);
                setMarketFromLink({
                    marketId,
                    betNumber,
                    odds,
                    live,
                    action,
                });
            }
            if (
                betslip.customBetBetslipFetched &&
                betslip.hasMarkets.length > 0
            ) {
                betslipActions.clearAllCustomBetMarkets(true);
                setMarketFromLink({
                    marketId,
                    betNumber,
                    odds,
                    live,
                    action,
                });
            }
            if (
                betslip.regularBetBetslipFetched &&
                betslip.customBetBetslipFetched &&
                betslip.hasMarkets.length === 0
            ) {
                if (action === 'add') {
                    betslipActions.addMarket(
                        marketId,
                        betNumber,
                        odds,
                        live,
                        0,
                        betslip.hasMarkets
                    );
                }
                browserHistory.push(goToWithBasePath(`/kamp/${params.id}`));
            }
        }
    };

    const checkDeviceWidth = () => {
        if (window.innerWidth > 1000) {
            setSideMatchCenter(true);
        } else {
            setSideMatchCenter(false);
        }
    };

    const handleSportRadarWidgetTabChange = (selectedTab) => {
        return selectedTab === SportRadarWidget.tabs.statistikker;
    };

    const getDynamicOrderedMarketGroups = () => {
        let markets = [];
        markets = getMarketsByMarketTypeGroup();
        setOrderedMarkets(markets);
    };

    const LiveSectionSkeleton = () => {
        return (
            <div className="live-section-skeleton-event">
                <div className="live-section-top" />
                <div className="live-section-middle" />
                <div className="live-section-bottom">
                    <div className="live-section-line" />
                    <div className="live-section-line-second" />
                </div>
            </div>
        );
    };
    const EventTabSkeleton = () => {
        const lines = Array.from({ length: 14 });
        return (
            <div className="event-page-skeleton">
                {lines.map((_, index) => (
                    <div key={index} className="event-page-skeleton-card" />
                ))}
            </div>
        );
    };
    const ComplexSkeleton = () => {
        const cards = Array.from({ length: 10 });

        return (
            <div className="complex-skeleton-container">
                <div className="complex-skeleton-header">
                    <div className="complex-skeleton-line" />
                    <div className="complex-skeleton-line" />
                </div>
                {cards.map((_, index) => (
                    <div key={index} className="complex-skeleton-card">
                        <div className="complex-skeleton-card-content">
                            <div>
                                <div className="complex-skeleton-line-long" />
                                <div className="complex-skeleton-line-short" />
                            </div>
                            <div className="complex-skeleton-blocks">
                                <div className="complex-skeleton-block" />
                                <div className="complex-skeleton-block" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };
    /**
     * @return {[{marketTypeGroupName: String, marketList: MarketModel[], marketTypeGroup: Number }]}
     */
    const getMarketsByMarketTypeGroup = () => {
        pending = true;
        if (eventObject?.data && eventObject?.data?.marketList?.length > 0) {
            setEventTitle(
                `${eventObject.data.sport} / ${eventObject.data.groupName} / ${
                    eventObject.data.competition
                }`
            );

            let betRequestWithMarketList = [];

            betRequestWithMarketList = eventObject.data.marketList
                .filter((item) => item.marketTypeGroupName === 'Kundeønsker')
                .map((item) => {
                    return {
                        ...item,
                        marketTypeGroup: MARKET_TYPE_GROUPS_ID.BET_REQUEST,
                    };
                });

            let betRequest = eventObject.data.betRequest
                ? betRequestWithMarketList.length > 0
                    ? betRequestWithMarketList
                    : [
                          {
                              marketTypeGroupName: 'Kundeønsker',
                              marketTypeGroup:
                                  MARKET_TYPE_GROUPS_ID.BET_REQUEST,
                              marketList: [],
                          },
                      ]
                : [{}];

            let CB =
                eventObject.data?.customBetMarkets?.length > 0
                    ? [...eventObject.data.customBetMarkets]
                    : [];

            const propsMarketList = [
                ...eventObject.data.marketList.filter(
                    (item) => item.marketTypeGroupName !== 'Kundeønsker'
                ),
                ...CB,
                ...betRequest,
            ];

            let mostPopularMarkets = [];
            mostPopularMarkets = getPopularMarkets(eventObject.data);

            let marketListFiltered = [];

            if (isTerminal()) {
                propsMarketList.map((item) => {
                    if (item.channels) {
                        marketListFiltered.push(item);
                    }
                });
            } else {
                marketListFiltered = [...propsMarketList];
            }

            let filtered = [];

            filtered = marketListFiltered
                .filter((item) =>
                    PRYORITED_MARKETS.includes(item?.marketTypeGroup)
                )
                .sort((a, b) => a?.marketTypeGroup - b?.marketTypeGroup)
                .map((item) => item?.marketTypeGroupName);

            const orderByMarketTypeGroupPriority = marketListFiltered
                .filter(
                    (item) => !PRYORITED_MARKETS.includes(item?.marketTypeGroup)
                )
                .sort(
                    (a, b) =>
                        a.marketTypeGroupPriority - b.marketTypeGroupPriority
                )
                .map((item) => item?.marketTypeGroupName);

            let ordered = [...filtered, ...orderByMarketTypeGroupPriority];

            let data = [...new Set([...ordered])].reduce(
                (acc, marketTypeGroupName) => {
                    const marketList = marketListFiltered
                        .filter(
                            (item) =>
                                item?.marketTypeGroupName ===
                                marketTypeGroupName
                        )
                        .sort((a, b) => {
                            if (a.marketTypePriority === b.marketTypePriority) {
                                return a.extraInfo - b.extraInfo;
                            } else {
                                return (
                                    a.marketTypePriority - b.marketTypePriority
                                );
                            }
                        });
                    const [{ marketTypeGroup }] = marketList;
                    let locMarketTypeGroup = marketTypeGroup;
                    let locMarketTypeGroupName = marketTypeGroupName;

                    if (locMarketTypeGroupName === '1X2') {
                        locMarketTypeGroupName = 'Mest populære odds';
                    }

                    if (
                        typeof locMarketTypeGroupName !== 'undefined' &&
                        typeof locMarketTypeGroup !== 'undefined'
                    ) {
                        acc.push({
                            marketTypeGroupName: locMarketTypeGroupName,
                            marketTypeGroup: locMarketTypeGroup,
                            marketList,
                        });
                    }
                    return acc;
                },
                []
            );

            if (mostPopularMarkets.length > 0) {
                let itemIndex = findIndexInObjectByMarketTypeGroup(
                    data,
                    MARKET_TYPE_GROUPS_ID._1X2
                );
                if (itemIndex < 0) {
                    data.unshift({
                        marketTypeGroupName: 'Mest populære odds',
                        marketTypeGroup: MARKET_TYPE_GROUPS_ID._1X2,
                        marketList: mostPopularMarkets,
                    });
                } else {
                    data[itemIndex].marketList = mostPopularMarkets;
                }
            }
            pending = false;

            return data;
        } else {
            return [];
        }
    };

    const findIndexInObjectByMarketTypeGroup = (data, marketTypeGroup) => {
        return data.findIndex(
            (item) => item.marketTypeGroup === marketTypeGroup
        );
    };
    const MobileEventPageSkeleton = () => {
        return (
            <div className="mobile-event-page-skeleton">
                <div className="header-container">
                    <div className="header-part">
                        <div className="header-circle" />
                        <div className="header-line header-line-left" />
                    </div>
                    <div className="header-part">
                        <div className="header-line header-line-right" />
                        <div className="header-circle" />
                    </div>
                </div>
                <div className="second-header-container">
                    <div className="header-line-long" />
                    <div className="header-line-second" />
                    <div className="header-line-third" />
                    <div className="header-line-long" />
                </div>
                {Array.from({ length: 2 }).map((_, index) => (
                    <div key={index} className="card">
                        <div className="card-top-container">
                            <div className="card-top">
                                <div className="card-line" />
                                <div className="card-line-short" />
                            </div>
                            <div className="card-line" />
                        </div>
                        <div className="card-bottom">
                            <div className="card-block" />
                            <div className="card-block card-block-middle" />
                            <div className="card-block" />
                        </div>
                    </div>
                ))}
                {Array.from({ length: 2 }).map((_, index) => (
                    <div key={index} className="card">
                        <div className="card-top-container">
                            <div className="card-top">
                                <div className="card-line" />
                                <div className="card-line-short" />
                            </div>
                            <div className="card-line" />
                        </div>
                        <div className="card-bottom">
                            <div className="card-block-event card-block-event-el" />
                            <div className="card-block-event" />
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const updateCustomBetMarkets = () => {
        let updatedCustomBetMarketList = eventObject?.data?.customBetMarkets;
        if (updatedCustomBetMarketList?.length > 0) {
            let index = findIndexInObjectByMarketTypeGroup(
                orderedMarkets,
                MARKET_TYPE_GROUPS_ID.CUSTOM_BET
            );

            const marketList = updatedCustomBetMarketList.sort((a, b) => {
                if (a.marketTypePriority === b.marketTypePriority) {
                    return a.extraInfo - b.extraInfo;
                } else {
                    return a.marketTypePriority - b.marketTypePriority;
                }
            });

            let marketsTmp = orderedMarkets;
            marketsTmp[index] = {
                ...marketsTmp[index],
                marketList,
            };

            setOrderedMarkets(marketsTmp);
        }
    };

    let header = <ViewSpinner />;
    let matchCenter = null;

    if (eventObject.fetched && eventObject.groupedMarkets) {
        const eventObj = eventObject.data;
        if (eventObj) {
            if (eventObj.sportId === SPORTS.HESTESPORT && auth?.user?.userId) {
                /*header = (
                    <header className="p10">
                        <div className="p10 text-center">
                            {eventObj.groupName} / {eventObj.competition} -{' '}
                            {eventObj.kickoffDate} Kl. {eventObj.kickoffTime}
                        </div>

                        <h4 className="text-center m0">{eventObj.eventName}</h4>
                    </header>
                );*/
                matchCenter = <HorseRacingStream />;
            } else if (eventObj && eventObj.awayTeam !== null) {
                header = null;

                const hasWidget =
                    SPORTS_ALLOW_MATCH_CENTER.includes(eventObj.sportId) &&
                    eventObj.externalId > 0;

                if (hasWidget) {
                    if (
                        (eventObj.live && eventObj.mts === 0) ||
                        eventObj.externalId === 0
                    ) {
                        matchCenter = (
                            <CommonMatchCenterPlaceholder event={eventObj} />
                        );
                    } else {
                        matchCenter = (
                            <SportRadarWidget
                                showTabSwitcher={true}
                                onTabChange={handleSportRadarWidgetTabChange}
                                container="srf-widget"
                                layout={
                                    detectMobile() && !sideMatchCenter
                                        ? 'single'
                                        : 'topdown'
                                }
                                event={eventObj}
                                externalId={eventObj.externalId}
                                isLive={eventObj.live}
                                collapseTo={
                                    !eventObj.live &&
                                    detectMobile() &&
                                    'scoreboard'
                                }
                            />
                        );
                    }
                    header = null;
                } else {
                    matchCenter = (
                        <div>
                            <div className="p10 text-center f14">
                                <img
                                    src={
                                        APP_PATH +
                                        '/img/sports/' +
                                        eventObj.sportId +
                                        '.png'
                                    }
                                    alt="icon"
                                    width="24"
                                    height="24"
                                    className="small-sport-icon"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                            APP_PATH +
                                            '/img/bet25sport_icon.svg';
                                    }}
                                />
                                {eventObj.groupName} {eventObj.competition} -{' '}
                                {eventObj.kickoffDate} Kl.{' '}
                                {eventObj.kickoffTime}
                            </div>
                            <h4 className="text-center m0">
                                {eventObj.eventName}
                            </h4>
                        </div>
                    );
                }
            } else {
                header = (
                    <header className="p10">
                        <div className="p10 text-center">
                            {eventObj.groupName} / {eventObj.competition} -{' '}
                            {eventObj.kickoffDate} Kl. {eventObj.kickoffTime}
                        </div>

                        <h4 className="text-center m0">{eventObj.eventName}</h4>
                    </header>
                );

                if (eventObj.sportId === 2231) {
                    matchCenter = null;
                }
            }
        }
    }

    let gamePageView =
        orderedMarkets.length > 0 ? (
            <GamePageTabView
                markets={orderedMarkets}
                uiActions={uiActions}
                auth={auth}
                eventId={params.id}
                eventObject={eventObject}
            />
        ) : (
            <ViewSpinner />
        );

    return (
        <div className={'gamePage'}>
            <>
                <BackButton
                    eventTitle={eventTitle}
                    isMobile={detectMobile()}
                    isLeftSideBarOpen={isLeftSideBarOpen}
                />
                <div className={'dividerContent'}>
                    {!detectMobile() &&
                        (!eventObject.pending ? (
                            <Text
                                margin="0"
                                padding="0"
                                size="24"
                                color="#333333"
                                bold
                                align="left"
                            >
                                {eventObject?.data?.eventName}
                            </Text>
                        ) : (
                            <div className="event-page-skeleton-line-large" />
                        ))}
                    {detectMobile() &&
                        eventObject.pending && <>{MobileEventPageSkeleton()}</>}
                    {/*TODO check when event is live but odds are disabled we get loader*/}
                    {!eventObject.pending
                        ? gamePageView
                        : !detectMobile() && (
                              <>
                                  {EventTabSkeleton()}
                                  {ComplexSkeleton()}
                              </>
                          )}
                </div>
                <div className={'dividerContent'}>
                    {!eventObject.pending ? (
                        <MatchCenterAndLiveStream
                            matchCenter={matchCenter}
                            streamId={eventObject?.data?.streamId}
                            sportId={eventObject?.data?.sportId}
                            groupName={eventObject?.data?.groupName}
                        />
                    ) : (
                        !detectMobile() && <>{LiveSectionSkeleton()}</>
                    )}
                </div>
            </>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        eventObject: state.eventObject,
        betslip: state.betslip,
        auth: state.auth,
        oldActiveSportId: state.uiSportLive.oldActiveSportId,
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setActiveSportId: bindActionCreators(SetActiveSportId, dispatch),
        eventObjectActions: bindActionCreators(EventObjectActions, dispatch),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GamePageLayout);
